import styled from 'styled-components';

export const TitleNormal = styled.div<{ color?: string; fontSize?: string | number }>`
  font-size: ${({ fontSize }) => (fontSize ? (typeof fontSize === 'number' ? `${fontSize}px` : fontSize) : '16px')}; /* fontSize prop을 받도록 수정 */
  font-weight: 400; /* Regular 폰트 */
  line-height: 1; /* 줄 간격 */
  color: ${(props) => props.color || '#232D42'}; /* color prop이 있으면 그 값을 사용하고, 없으면 기본 색상 */
  font-family: ${(props) => props.theme.typography.fontFamily};

  cursor: ${(props) => (props.onClick ? 'pointer' : 'default')}; /* onClick 속성 여부로 결정 */
`;

export const TitleLarge = styled(TitleNormal)`
  font-size: ${({ fontSize }) => (fontSize ? (typeof fontSize === 'number' ? `${fontSize}px` : fontSize) : '33px')}; /* 기본 크기 33px */
`;

export const TitleLargeMedium = styled(TitleLarge)`
  font-weight: 475;
`;

export const TitleMedium = styled(TitleNormal)`
  font-size: ${({ fontSize }) => (fontSize ? (typeof fontSize === 'number' ? `${fontSize}px` : fontSize) : '20px')}; /* 기본 크기 20px */
`;

export const TitleMediumBold = styled(TitleMedium)`
  font-weight: 700;
`;

export const TitleSmall = styled(TitleNormal)`
  font-size: ${({ fontSize }) => (fontSize ? (typeof fontSize === 'number' ? `${fontSize}px` : fontSize) : '13px')}; /* 기본 크기 13px */
`;

export const TitleNormalBold = styled(TitleNormal)`
  font-weight: 700; /* Bold 폰트로 변경 */
`;

export const TextLeftMenuSection = styled(TitleNormal)`
  font-weight: 700; /* Bold 폰트로 변경 */
  color: #FFFFFF;
  margin-left: 32px;
  margin-top: 12px; 
  margin-bottom: 12px;
  font-size: 18px;
`;